import type { IAuthTokenService } from "@src/domain/interfaces";

export abstract class AuthTokenService implements IAuthTokenService {
  abstract getAuthAccessToken(): Promise<string | null>;
  abstract getAdminAccessToken(): Promise<string | null>;
  abstract getAdminRefreshToken(): Promise<string | null>;
}